import {Controller} from "@/controllers/Controller";

/**
 * Controller for group API
 */
export class CollectionController extends Controller {

     static getAllByBusiness(businessId, urlParams) {
         return this.requestBuilder("GET",`/business/collections/by-business/${businessId}?${urlParams}`, true);
     }

     static patch(id, body) {
         return this.requestBuilder("PATCH",`/business/collections/${id}`, true, body);
     }

     static post(body) {
         return this.requestBuilder("POST",`/business/collections`, true, body);
     }

}
